<template>
	<el-row class="type-opr">
	  <el-col :span="12">
	    <el-button type="primary" size="medium" plain icon="el-icon-download">导出excel</el-button>
	  </el-col>
	  <el-col :span="12" style="text-align: right">
	    <span >排序方式：</span>
	    <el-button-group>
	      <el-button type="success" size="medium" plain>下载量<i class="el-icon-bottom el-icon--right"></i></el-button>
	      <el-button type="primary" size="medium" plain>浏览数<i class="el-icon-bottom el-icon--right"></i></el-button>
	    </el-button-group>
	  </el-col>
	</el-row>
</template>

<script>
	export default {
	    name: "operation",
	    data(){
	        return{
	            
	        }
	    },
	    methods:{
	
	    },
	    mounted() {
	
	    }
	
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/operation.vue